import { config } from "../config";
import { OktaAuth } from "@okta/okta-auth-js";

const oktaInstance = new OktaAuth({
  scopes: ["openid", "profile", "email"],
  responseType: ["token", "id_token"],
  pkce: true,
  tokenManager: {
    autoRenew: true,
    autoRemove: true,
    storage: "sessionStorage",
  },
  ...config.okta,
});

export default oktaInstance;
